import { listAccountsByCompanyUid } from "~/context/Accounts/application/listAccountsByCompanyUid";
import { Dependencies } from "~/context/Shared/infrastructure/Dependencies";

export function useAccountsCompany(companyId: string) {
  const accounts = listAccountsByCompanyUid(Dependencies.getInstance().getAccountRepository(), companyId);
  return accounts;
}
